import { Link } from '@dapperlabs/core-fe';

interface Props {
  href: string;
  isDropOngoing?: boolean;
  label: string;
}

export const CTAButton = ({ label, href, isDropOngoing = false }: Props) => (
  <Link
    display='inline-block'
    w='100%'
    py={2}
    color={isDropOngoing ? 'black' : '#F8F8F8'}
    fontFamily='mono'
    fontSize='md'
    fontWeight={400}
    letterSpacing='-0.16px'
    textAlign='center'
    textDecoration='none'
    border={isDropOngoing ? '' : 'solid 1px #F8F8F8'}
    borderRadius='40px'
    backgroundColor={isDropOngoing ? '#F8F8F8' : 'black'}
    href={href}
  >
    {label}
  </Link>
);
